var _path, _circle, _circle2, _path2, _circle3, _path3, _circle4, _path4, _circle5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransitGatewayDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20c0 10.493-8.507 19-19 19S1 30.493 1 20 9.507 1 20 1s19 8.507 19 19z",
    fill: "#2C1C55",
    stroke: "#A48BE3",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 4.647,
    stroke: "#A48BE3",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7.765,
    r: 2.765,
    stroke: "#A48BE3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A48BE3",
    strokeWidth: 2,
    d: "M19.941 15.294V9.647"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.235,
    cy: 20,
    r: 2.765,
    transform: "rotate(90 32.235 20)",
    stroke: "#A48BE3",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A48BE3",
    strokeWidth: 2,
    d: "M24.706 19.941h5.647"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 32.235,
    r: 2.765,
    transform: "rotate(-180 20 32.235)",
    stroke: "#A48BE3",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A48BE3",
    strokeWidth: 2,
    d: "M20.059 24.706v5.647"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.765,
    cy: 20,
    r: 2.765,
    transform: "rotate(-90 7.765 20)",
    stroke: "#A48BE3",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A48BE3",
    strokeWidth: 2,
    d: "M15.294 20.059H9.647"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk5OTkgMjBDMzguOTk5OSAzMC40OTM0IDMwLjQ5MzMgMzkgMjAgMzlDOS41MDY1NyAzOSAxIDMwLjQ5MzQgMSAyMEMxIDkuNTA2NTkgOS41MDY1NyAxIDIwIDFDMzAuNDkzMyAxIDM4Ljk5OTkgOS41MDY1OSAzOC45OTk5IDIwWiIgZmlsbD0iIzJDMUM1NSIgc3Ryb2tlPSIjQTQ4QkUzIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iNC42NDcwNiIgc3Ryb2tlPSIjQTQ4QkUzIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSI3Ljc2NDcxIiByPSIyLjc2NDcxIiBzdHJva2U9IiNBNDhCRTMiIHN0cm9rZS13aWR0aD0iMiIvPgo8bGluZSB4MT0iMTkuOTQxMiIgeTE9IjE1LjI5NDEiIHgyPSIxOS45NDEyIiB5Mj0iOS42NDcwMSIgc3Ryb2tlPSIjQTQ4QkUzIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMzIuMjM1MyIgY3k9IjIwLjAwMDEiIHI9IjIuNzY0NzEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDMyLjIzNTMgMjAuMDAwMSkiIHN0cm9rZT0iI0E0OEJFMyIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHgxPSIyNC43MDU5IiB5MT0iMTkuOTQxIiB4Mj0iMzAuMzUyOSIgeTI9IjE5Ljk0MSIgc3Ryb2tlPSIjQTQ4QkUzIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIzMi4yMzUzIiByPSIyLjc2NDcxIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDIwIDMyLjIzNTMpIiBzdHJva2U9IiNBNDhCRTMiIHN0cm9rZS13aWR0aD0iMiIvPgo8bGluZSB4MT0iMjAuMDU4OSIgeTE9IjI0LjcwNTkiIHgyPSIyMC4wNTg5IiB5Mj0iMzAuMzUzIiBzdHJva2U9IiNBNDhCRTMiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSI3Ljc2NDcxIiBjeT0iMTkuOTk5OSIgcj0iMi43NjQ3MSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDcuNzY0NzEgMTkuOTk5OSkiIHN0cm9rZT0iI0E0OEJFMyIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHgxPSIxNS4yOTQxIiB5MT0iMjAuMDU5IiB4Mj0iOS42NDcwNiIgeTI9IjIwLjA1OSIgc3Ryb2tlPSIjQTQ4QkUzIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgTransitGatewayDark as ReactComponent };